import { render, staticRenderFns } from "./recipe-rating.vue?vue&type=template&id=5a270946&"
import script from "./recipe-rating.vue?vue&type=script&lang=js&"
export * from "./recipe-rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports